import { request } from './apiClient';

// Lista o catálogo de tipos de cimento do cliente (resolvido pelo token) somado aos natos.
export const getTipoCimento = async () => {
    return await request("/api/tipoCimento");
};

// Cria um tipo de cimento. O idCliente vem do token, não do corpo.
export const createTipoCimento = async (tipoCimentoData) => {
    return await request("/api/tipoCimento", {
        method: 'POST',
        body: JSON.stringify(tipoCimentoData)
    });
};

// Atualiza um tipo de cimento por id.
export const updateTipoCimento = async (idTipoCimento, tipoCimentoData) => {
    return await request(`/api/tipoCimento/${idTipoCimento}`, {
        method: 'PUT',
        body: JSON.stringify(tipoCimentoData)
    });
};
// Exclui um tipo de cimento por id.
export const deleteTipoCimento = async (idTipoCimento) => {
    return await request(`/api/tipoCimento/${idTipoCimento}`, {
        method: 'DELETE'
    })
}
